import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ModalProvider, useModal } from "@/components/essex/ModalContext";
import CheckDateModal from "@/components/essex/CheckDateModal";
import EssexWeddingVideo from "@/pages/EssexWeddingVideo";
import VenuePage from "@/pages/VenuePage";
import RealWeddings from "@/pages/RealWeddings";
import About from "@/pages/About";
import GuidePage from "@/pages/GuidePage";
import VideoPhotoLanding from "@/pages/VideoPhotoLanding";
import WhyUsPage from "@/pages/WhyUsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, location.state]);
  return null;
}

function GlobalModal() {
  const { isModalOpen, closeModal } = useModal();
  return <CheckDateModal isOpen={isModalOpen} onClose={closeModal} />;
}

function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <ModalProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<EssexWeddingVideo />} />
              <Route path="/essex" element={<EssexWeddingVideo />} />
              <Route path="/about" element={<About />} />
              <Route path="/guide" element={<GuidePage />} />
              <Route path="/real-weddings" element={<RealWeddings />} />
              <Route path="/video-photo" element={<VideoPhotoLanding />} />
              <Route path="/why-us" element={<WhyUsPage />} />
              <Route path="/:slug" element={<VenuePage />} />
            </Routes>
          </BrowserRouter>
          <GlobalModal />
        </ModalProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
